import { BUSINESS } from "@/data/content";

export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 left-0 right-0 z-50 bg-[#050505] text-white"
      style={{ height: "var(--announce-h, 40px)" }}
    >
      <div className="mx-auto flex h-full max-w-[1400px] items-center justify-center px-3">
        <p
          className="w-full whitespace-nowrap text-center text-white/90"
          style={{ fontSize: "min(2.9vw, 15px)" }}
        >
          {BUSINESS.announcement}
        </p>
      </div>
    </div>
  );
}
